import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import Button from "@khanacademy/wonder-blocks-button";
import {View} from "@khanacademy/wonder-blocks-core";
import {Body, HeadingLarge} from "@khanacademy/wonder-blocks-typography";
import {mediaQueries} from "@repo/shared-styles";
import {cssUrl} from "@repo/urls";

import {PAGE_WIDTH} from "./styles.ts";
import type {Images, Strings} from "./types.ts";

type Props = {
    strings: Strings;
    images: Images;
};

export default class Footer extends React.Component<Props> {
    render(): React.ReactNode {
        const {strings, images} = this.props;

        return (
            <View style={styles.footer}>
                <View style={styles.left}>
                    <HeadingLarge>{strings.partnership}</HeadingLarge>
                    <Body style={styles.body}>
                        {strings.partnershipDescription}
                    </Body>
                    <View style={styles.btnContainer}>
                        <Button href={strings.partnershipLink}>
                            {strings.ctaGetStarted}
                        </Button>
                    </View>
                </View>
                <View style={styles.right}>
                    <div
                        className={css(styles.image)}
                        style={{
                            backgroundImage: cssUrl(images.footer),
                        }}
                    />
                </View>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    footer: {
        marginTop: 64,
        maxWidth: PAGE_WIDTH,
        alignSelf: "center",
        marginBottom: 32,
        flexDirection: "row",
        [mediaQueries.mdOrSmaller]: {
            marginLeft: 24,
            marginRight: 24,
            marginTop: 48,
            marginBottom: 48,
        },
        [mediaQueries.smOrSmaller]: {
            flexDirection: "column",
        },
    },
    body: {
        marginTop: 16,
        marginBottom: 24,
    },
    btnContainer: {
        flexDirection: "row",
        [mediaQueries.smOrSmaller]: {
            flexDirection: "column",
            maxWidth: 188,
            justifyContent: "center",
        },
    },
    left: {
        paddingRight: 32,
        paddingTop: "5%",
        flex: 1,
        [mediaQueries.mdOrSmaller]: {
            paddingRight: 0,
            paddingTop: 0,
        },
    },
    right: {
        minWidth: 352,
        alignItems: "end",
        display: "flex",
        flex: 1,
        [mediaQueries.md]: {
            justifyContent: "center",
        },
        [mediaQueries.mdOrSmaller]: {
            minWidth: "auto",
        },
        [mediaQueries.smOrSmaller]: {
            marginTop: 48,
            width: "100%",
            height: "auto",
            minHeight: 162,
            justifyContent: "center",
        },
    },
    image: {
        width: 505,
        height: 425,
        borderRadius: 4,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        [mediaQueries.mdOrSmaller]: {
            width: 160,
            height: 164,
            alignSelf: "center",
        },
        [mediaQueries.smOrSmaller]: {
            alignSelf: "center",
        },
    },
});
